module.exports = __webpack_public_path__ + "99f44725669b15c502abfc1ff6b6bf65.svg";